<template>
  <v-select
    v-model="selected"
    :items="options"
    item-text="Name"
    item-value="value"
    :clearable="!disabled"
    :outlined="!disabled"
    :filled="disabled"
    dense
    hide-details="true"
    label="Network"
    id="networkSelect"
    @input="val => $emit('update', val)"
    :disabled="disabled"
  ></v-select>
</template>

<script>
import { fetchMarketingNetworks } from '@/api'

export default {
  props: {
    initialValue: null,
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      optionSet: [],
      selected: this.initialValue || '',
    }
  },
  created () {
    fetchMarketingNetworks().then(resp => {
      this.optionSet = resp
    })
  },
  computed: {
    options () {
      let optionValues = []
      if (this.optionSet) {
        this.optionSet.forEach(network => {
          optionValues.push({Name: network.network, value: network.network})
        })
        return optionValues
      } else {
        return []
      }
    },
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// MarketingNetworkSelect.vue?2daeb2ee